import type { StateUpdater } from '../../../canvas/core';
import type { PageId } from '../../core';
import type { TranslationLayerSlice } from './types';

export const setActiveRect =
  <Root extends TranslationLayerSlice>(
    pageId: PageId,
    rectId: string
  ): StateUpdater<Root> =>
  state => {
    // Skip update if already set to avoid re-renders
    if (
      state.translationLayer.state.activeRectId === rectId &&
      state.translationLayer.state.activePageId === pageId
    ) {
      return state;
    }

    return {
      ...state,
      translationLayer: {
        ...state.translationLayer,
        state: {
          activeRectId: rectId,
          activePageId: pageId,
        },
      },
    };
  };

export const clearActiveRect =
  <Root extends TranslationLayerSlice>(): StateUpdater<Root> =>
  state => {
    // Skip update if already cleared
    if (
      state.translationLayer.state.activeRectId === null &&
      state.translationLayer.state.activePageId === null
    ) {
      return state;
    }

    return {
      ...state,
      translationLayer: {
        ...state.translationLayer,
        state: {
          activeRectId: null,
          activePageId: null,
        },
      },
    };
  };
